import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import FollowPageMatrice from "../../pages/lakayUser/followPageMatrice";
import { elakay_API, toImageUrl } from "../../../config";
import Price from "../../pageInside/productsPrice";
import elakayEmptyBox from "../../Layout/icon/elakayEmptyBox.png";
import "./SwiperPageMatrix.css";
import { getDefaultTitleStyle } from "../../../utils/titleStyle";
import { getProductPrimaryImage } from "../../auth/elakay-utils";

import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";

import useElakaySwiper from "../swiperSettings/useElakaySwiper";
import { legacyTableFrom } from "../swiperSettings/swiperSettingsModel";
// 0.2rem
// Exported so MatrixCardsGrid.jsx (the "all cards" full-page grid used by
// Search History / Viewing Activity / Shops You Follow) can reuse the exact
// same per-card data shaping instead of duplicating it.
export function getLastItem(array = []) {
  if (!Array.isArray(array) || array.length === 0) return null;
  return array[array.length - 1];
}

export const getImageUrl = (item) => getProductPrimaryImage(item) || null;

export function processData(input) {
  const data = Array.isArray(input) ? input : [input];

  const cleaned = data.map((item) => ({
    ...item,
    name: Array.isArray(item?.name)
      ? item.name
          .map((n) => (typeof n === "string" ? n.trim() : n))
          .filter((n) => (typeof n === "string" ? n.length > 0 : Boolean(n)))
      : [],
  }));

  const allNames = cleaned.flatMap((item) => item.name);
  const nameCounts = allNames.reduce((acc, name) => {
    acc[name] = (acc[name] || 0) + 1;
    return acc;
  }, {});

  const GENDERS = new Set(["Men", "Women", "Boys", "Girls", "Babies"]);

  return cleaned.map((item) => {
    const filteredNames = item.name.filter(
      (name) => nameCounts[name] < cleaned.length
    );
    const genderGroup = filteredNames.find((name) => GENDERS.has(name));
    const main = item.name?.[0] ?? "";
    const cateryName = [genderGroup, main].filter(Boolean).join(" ").trim();

    return {
      ...item,
      cateryName: cateryName || main || null,
      categoryName: cateryName || main || null,
    };
  });
}

const SwiperPageMatrix = (props) => {
  const {
    nbrArr = 3,
    title = "",
    titleKey,
    infoSource,
    myStyles,
    wm0 = 1.3,
    wm640 = 2,
    wm768 = 2,
    wm1024 = 3,
    wm1200 = 3,
    // shop user categories
    userID,
    pubCategoryProd,
    shop = false,
    inView = false,
    setSearch,
    setCi,
    setShopUser,
    getShopName,
    productsrMatrix = [],

    // 🔗 SECTION-LEVEL "See More" — opens the new all-cards page for this
    // matrix (e.g. /search-history, /viewing-activity, /shops-you-follow).
    // Distinct from FollowPageMatrice's own per-card "View All" (slideLinkText)
    // which keeps opening the existing single-category/single-shop page —
    // this link is never passed down to the cards.
    linkSlider = null,
    classLink  = '',



        // 🎨 TITRE SECONDAIRE (card-title)
        showSlideTitle          = false,
        slideTitleFontFamily    = 'inherit',
        slideTitleFontSize      = '1rem',
        slideTitleFontWeight    = 600,
        slideTitleFontStyle     = 'normal',
        slideTitleLetterSpacing = 'normal',
        slideTitleLineHeight    = 1.2,
        slideTitleTextTransform = 'none',
        slideTitleTextAlign     = 'left',
        slideTitleColor         = '#1f2937',
        slideTitleTextShadow    = 'none',
        slideTitleAnimation     = null,

        // 🔗 LIEN SECONDAIRE (card-subtitle)
        showSlideLink               = false,
        slideLinkText               = 'seeMore',
        slideLinkFontFamily         = 'inherit',
        slideLinkFontSize           = '0.875rem',
        slideLinkFontWeight         = 500,
        slideLinkFontStyle          = 'normal',
        slideLinkLetterSpacing      = 'normal',
        slideLinkTextTransform      = 'none',
        slideLinkTextDecoration     = 'none',
        slideLinkColor              = '#007399',
        slideLinkHoverColor         = '#005577',
        slideLinkBackgroundColor    = 'transparent',
        slideLinkPadding            = '0',
        slideLinkBorderRadius       = '0',
        slideLinkTextShadow         = 'none',
        slideLinkClass              = '',

        // 🔗 LIEN — clé de traduction + styles
    linkText            = 'seeMore',      // clé dans languageAPI.Link
    linkFontFamily      = 'inherit',
    linkFontSize        = '0.9rem',
    linkFontWeight      = 500,
    linkFontStyle       = 'normal',
    linkLetterSpacing   = 'normal',
    linkTextTransform   = 'none',
    linkTextDecoration  = 'none',
    linkColor           = '#007399',
    linkHoverColor      = '#005577',
    linkBackgroundColor = 'transparent',
    linkPadding         = '0',
    linkBorderRadius    = '0',
    linkTextShadow      = 'none',
    linkClass           = '',

    // ============================================
    // 🎬 PROPS ANIMATION CONTAINER (0-32)
    // ============================================
    type_Animation = null, // "0_type_Animation" à "32_type_Animation"
    animation = false, // Rétrocompatibilité - ancien système
    backgroundColor = "#DCDCDC",
    containerFusion = false, // Fond, bordure et ombre transparents — fusionne le conteneur avec la page
    containerBorder = null, // ex: "1px solid #e5e7eb"
    containerBorderRadius = null, // ex: "12px"
    containerBoxShadow = null, // ex: "0 4px 20px rgba(0,0,0,0.08)"

    // ============================================
    // 🎨 PROPS TITRE - POLICE & STYLE
    // ============================================
    // Défauts non fixés en dur : voir getDefaultTitleStyle() (utils/titleStyle.js)
    // — AnimationSettings → General → "Default Title Styles" fournit la valeur
    // par défaut si aucune de ces props n'est explicitement passée.
    titleFontFamily, // Police du titre: "Arial", "Roboto", "Poppins", etc.
    titleFontSize, // "1.5rem", "2rem", "24px", etc.
    titleFontWeight, // Graisse: 400, 500, 600, 700, 800, 900
    titleFontStyle, // Style: "normal", "italic", "oblique"
    titleLetterSpacing, // Espacement lettres: "-1px", "0", "2px"
    titleLineHeight, // Hauteur de ligne: 1, 1.2, 1.5, "normal"
    titleTextTransform, // Transform: "none", "uppercase", "lowercase", "capitalize"
    titleTextAlign, // Alignement: "left", "center", "right"

    // ============================================
    // 🎨 PROPS TITRE - COULEURS
    // ============================================
    titleColor, // Couleur texte du titre
    titleTextShadow, // Ombre du texte

    // ============================================
    // 🎬 PROPS TITRE - ANIMATION (0-32)
    // ============================================
    titleAnimation = null, // "animated_0" à "animated_32" ou null pour désactiver
    titleAnimationColors = null, // { primary: "#...", accent: "#..." } ou null pour défaut

    // ============================================
    // 🎬 PROPS HEADER - ANIMATION (0-32)
    // ============================================
    headerAnimation = null, // "animated_0" à "animated_32" ou null pour désactiver
    headerAnimationColors = null, // { primary: "#...", accent: "#..." } ou null pour défaut

    // ============================================
    // 🎨 PROPS HEADER - STYLE
    // ============================================
    headerBackgroundColor = "transparent", // Couleur de fond du header
    headerPadding = null, // Padding personnalisé: "1rem", "10px 20px"
    headerMarginBottom = null, // Marge en bas: "1rem", "20px"

    // ============================================
    // 🎨 COULEURS D'ANIMATION GLOBALES
    // ============================================
    animationColors = {
      // Type 0 - Version originale (arc-en-ciel)
      "0_type_Animation": {
        primary: "#007399",
        accent: "#3b82f6",
        secondary: "#8b5cf6",
      },
      // Type 1 - Rose et Violet
      "1_type_Animation": {
        primary: "#e91e63",
        accent: "#9c27b0",
        light1: "#fce4ec",
        light2: "#f3e5f5",
      },
      // Type 2 - Vert et Jaune
      "2_type_Animation": {
        primary: "#4caf50",
        accent: "#ffeb3b",
        light1: "#e8f5e9",
        light2: "#fffde7",
      },
      // Type 3 - Orange et Rouge
      "3_type_Animation": {
        primary: "#ff9800",
        accent: "#f44336",
        light1: "#fff3e0",
        light2: "#ffebee",
      },
      // Type 4 - Bleu et Indigo
      "4_type_Animation": {
        primary: "#2196f3",
        accent: "#3f51b5",
        light1: "#e3f2fd",
        light2: "#e8eaf6",
      },
      // Type 5 - Cyan et Teal
      "5_type_Animation": {
        primary: "#00bcd4",
        accent: "#009688",
        light1: "#e0f7fa",
        light2: "#e0f2f1",
      },
      // Type 6 - Or et Bronze (Premium)
      "6_type_Animation": {
        primary: "#ffd700",
        accent: "#cd7f32",
        light1: "#fffde7",
        light2: "#fff8e1",
      },
      // Type 7 - Argent et Platine
      "7_type_Animation": {
        primary: "#c0c0c0",
        accent: "#e5e4e2",
        light1: "#fafafa",
        light2: "#f5f5f5",
      },
      // Type 8 - Neon Magenta et Cyan
      "8_type_Animation": {
        primary: "#ff00ff",
        accent: "#00ffff",
        light1: "#fff0ff",
        light2: "#e0ffff",
      },
      // Type 9 - Rainbow
      "9_type_Animation": {
        primary: "#ff0000",
        accent: "#00ff00",
        secondary: "#0000ff",
        tertiary: "#ffff00",
      },
      // Type 10 - Deep Purple et Lavender
      "10_type_Animation": {
        primary: "#673ab7",
        accent: "#b39ddb",
        light1: "#ede7f6",
        light2: "#d1c4e9",
      },
      // Type 11 - Lime et Chartreuse
      "11_type_Animation": {
        primary: "#cddc39",
        accent: "#8bc34a",
        light1: "#f9fbe7",
        light2: "#dcedc8",
      },
      // Type 12 - Pink et Fuchsia
      "12_type_Animation": {
        primary: "#e91e63",
        accent: "#9c27b0",
        light1: "#fce4ec",
        light2: "#f3e5f5",
      },
      // Type 13 - Amber et Honey
      "13_type_Animation": {
        primary: "#ffc107",
        accent: "#ffa000",
        light1: "#fff8e1",
        light2: "#ffecb3",
      },
      // Type 14 - Brown et Tan
      "14_type_Animation": {
        primary: "#795548",
        accent: "#bcaaa4",
        light1: "#efebe9",
        light2: "#d7ccc8",
      },
      // Type 15 - Blue Grey et Slate
      "15_type_Animation": {
        primary: "#607d8b",
        accent: "#90a4ae",
        light1: "#eceff1",
        light2: "#cfd8dc",
      },
      // Type 16 - Coral et Peach
      "16_type_Animation": {
        primary: "#ff7f50",
        accent: "#ffdab9",
        light1: "#fff5ee",
        light2: "#ffefd5",
      },
      // Type 17 - Blanc et Turquoise Premium
      "17_type_Animation": {
        primary: "#007399",
        accent: "#4facfe",
        light1: "#e8f4f8",
        light2: "#d4ecf7",
      },
      // Type 18 - Matrix Digital Rain
      "18_type_Animation": {
        primary: "#00ff41",
        accent: "#00c832",
        light1: "#0d1a0d",
        light2: "#001a00",
      },
      // Type 19 - Neon Glow
      "19_type_Animation": {
        primary: "#ff0080",
        accent: "#00ffff",
        light1: "#1a0a1a",
        light2: "#0a1a1a",
      },
      // Type 20 - Liquid Blob
      "20_type_Animation": {
        primary: "#667eea",
        accent: "#764ba2",
        light1: "#eef2ff",
        light2: "#faf5ff",
      },
      // Type 21 - Holographic / Prism
      "21_type_Animation": {
        primary: "#ff0080",
        accent: "#40e0d0",
        secondary: "#ff8c00",
        tertiary: "#8000ff",
      },
      // Type 22 - Electric Storm
      "22_type_Animation": {
        primary: "#ffff00",
        accent: "#ffc800",
        light1: "#1a1a2e",
        light2: "#16213e",
      },
      // Type 23 - Orbital / Sunset
      "23_type_Animation": {
        primary: "#ffc864",
        accent: "#ff9632",
        light1: "#fff8f0",
        light2: "#fff0e0",
      },
      // Type 24 - Water Ripples / Ocean
      "24_type_Animation": {
        primary: "#0096c8",
        accent: "#00c8fa",
        light1: "#e6f7ff",
        light2: "#ccefff",
      },
      // Type 25 - Smoke Rising
      "25_type_Animation": {
        primary: "#c8c8c8",
        accent: "#969696",
        light1: "#f5f5f5",
        light2: "#e0e0e0",
      },
      // Type 26 - Confetti Celebration
      "26_type_Animation": {
        primary: "#ff6b6b",
        accent: "#4ecdc4",
        secondary: "#ffe66d",
        tertiary: "#95e1d3",
      },
      // Type 27 - Sparkle Stars
      "27_type_Animation": {
        primary: "#ffffc8",
        accent: "#ffffff",
        light1: "#0c1445",
        light2: "#1a237e",
      },
      // Type 28 - Hexagon Grid / Tech Blue
      "28_type_Animation": {
        primary: "#3498db",
        accent: "#2ecc71",
        light1: "#ecf0f1",
        light2: "#bdc3c7",
      },
      // Type 29 - Triangle Pattern / Soft Pink
      "29_type_Animation": {
        primary: "#ff9a9e",
        accent: "#fad0c4",
        light1: "#fff5f5",
        light2: "#fff0ed",
      },
      // Type 30 - Morphing Square / Lavender
      "30_type_Animation": {
        primary: "#a18cd1",
        accent: "#fbc2eb",
        light1: "#f5f0ff",
        light2: "#fff0f8",
      },
      // Type 31 - Energy Burst
      "31_type_Animation": {
        primary: "#ff6464",
        accent: "#6464ff",
        light1: "#fff0f0",
        light2: "#f0f0ff",
      },
      // Type 32 - Northern Lights / Aurora
      "32_type_Animation": {
        primary: "#00ff80",
        accent: "#00c8ff",
        secondary: "#8000ff",
        light1: "#0c1445",
        light2: "#1a237e",
      },
    }
  } = props;

  const arrayFacet = ["userViewMatrix", "historySearchMatrix", "followShopUser"];
  const classSlider = props.classSlider
    ? props.classSlider
    : "styles.sliderProduct";
  let lastProduct = getLastItem(productsrMatrix);

  // ============================================
  // 🎬 LOGIQUE ANIMATION CONTAINER
  // ============================================
  const getAnimationClass = () => {
    if (type_Animation) {
      const validTypes = Array.from({ length: 33 }, (_, i) => `${i}_type_Animation`);
      if (validTypes.includes(type_Animation)) {
        return type_Animation;
      }
    }
    if (animation === true || animation === "true") {
      return "0_type_Animation";
    }
    return "";
  };

  const animationClass = getAnimationClass();
 
  const isAnimated = animationClass !== "";


  // ============================================
  // 🎬 LOGIQUE ANIMATION TITRE
  // ============================================
  const getTitleAnimationClass = () => {
    if (titleAnimation === false || titleAnimation === "none") {
      return "";
    }
    if (titleAnimation) {
      const validAnimations = Array.from({ length: 33 }, (_, i) => `animated_${i}`);
      if (validAnimations.includes(titleAnimation)) {
        return titleAnimation;
      }
    }
    // Si pas de titleAnimation spécifié mais container animé, utiliser l'animation correspondante
    // if (isAnimated && titleAnimation === null) {
    //   const typeNumber = animationClass.replace("_type_Animation", "");
    //   return `animated_${typeNumber}`;
    // }
    return "";
  };

  const titleAnimClass = getTitleAnimationClass();

  // ============================================
  // 🎬 LOGIQUE ANIMATION HEADER
  // ============================================
  const getHeaderAnimationClass = () => {
    if (headerAnimation === false || headerAnimation === "none") {
      return "";
    }
    if (headerAnimation) {
      const validAnimations = Array.from({ length: 33 }, (_, i) => `animated_${i}`);
      if (validAnimations.includes(headerAnimation)) {
        return headerAnimation;
      }
    }
    // Si pas de headerAnimation spécifié mais container animé, utiliser l'animation correspondante
    // if (isAnimated && headerAnimation === null) {
    //   const typeNumber = animationClass.replace("_type_Animation", "");
    //   return `animated_${typeNumber}`;
    // }
    return "";
  };

  const headerAnimClass = getHeaderAnimationClass();

  // ============================================
  // 🎨 CLASSES CSS CONDITIONNELLES
  // ============================================
  const containerClass = isAnimated
    ? `page-matrix-swiper-container ${animationClass}`
    : "page-matrix-swiper-container";

  const headerClass = headerAnimClass
    ? `page-matrix-header ${headerAnimClass}`
    : "page-matrix-header";

  const titleClass = titleAnimClass
    ? `page-matrix-title ${titleAnimClass}`
    : "page-matrix-title";

  // Options: page instance > Animation Settings -> Swiper Settings > origin.
  // wm* passed by the page are that instance's own slides-per-view.
  const swp = useElakaySwiper("pageMatrix", {
    swiperOptions: props.swiperOptions,
    legacyTable: legacyTableFrom({ wm0, wm640, wm768, wm1024, wm1200 }, { 0: 15, 1024: 20 }),
    legacyExplicit: ["wm0", "wm640", "wm768", "wm1024", "wm1200"].some((key) => props[key] !== undefined),
    autoNavigation: Boolean(infoSource?.navigation),
  });
  const swiperClass = isAnimated
    ? `page-matrix-swiper ${animationClass}`
    : "page-matrix-swiper";

  // ============================================
  // 🎨 OBTENIR LES COULEURS D'ANIMATION
  // ============================================
  const getCurrentColors = () => {
    if (!isAnimated) return null;
    return animationColors[animationClass] || animationColors["0_type_Animation"];
  };

  const colors = getCurrentColors();

  // ============================================
  // 🎨 STYLES INLINE
  // ============================================

  // Style de bordure / rayon / ombre du container
  const borderStyle = {
    ...(containerBorder && { border: containerBorder }),
    ...(containerBorderRadius && { borderRadius: containerBorderRadius }),
    ...(containerBoxShadow && { boxShadow: containerBoxShadow }),
  };

  // Style de fusion : fond, bordure et ombre transparents (le conteneur se fond avec la page)
  const fusionStyle = containerFusion
    ? { backgroundColor: "transparent", border: "none", boxShadow: "none" }
    : null;

  // Style du container
  const containerStyle = !isAnimated
    ? { backgroundColor, ...myStyles, ...borderStyle, ...fusionStyle }
    : { ...myStyles, ...borderStyle, ...fusionStyle };

  // CSS Variables pour les animations du container
  const animationStyle =
    isAnimated && colors
      ? {
          "--anim-primary": colors.primary,
          "--anim-accent": colors.accent,
          "--anim-secondary": colors.secondary || colors.primary,
          "--anim-tertiary": colors.tertiary || colors.accent,
          "--anim-light1": colors.light1 || "#f0f0f0",
          "--anim-light2": colors.light2 || "#e0e0e0",
          ...myStyles,
          ...borderStyle,
          ...fusionStyle,
        }
      : { ...myStyles, ...borderStyle, ...fusionStyle };

  // Style du Header
  const headerStyle = {
    backgroundColor: headerBackgroundColor,
    ...(headerPadding && { padding: headerPadding }),
    ...(headerMarginBottom && { marginBottom: headerMarginBottom }),
    // CSS Variables pour les couleurs d'animation du header
    ...(headerAnimClass &&
      headerAnimationColors && {
        "--header-anim-primary": headerAnimationColors.primary,
        "--header-anim-accent": headerAnimationColors.accent,
      }),
  };

  // Style du Titre — priorité : props explicites > AnimationSettings
  // "Default Title Styles" > défauts codés en dur (voir titleStyle.js).
  const titlePresentation = getDefaultTitleStyle(infoSource?.allSettings?.defaultTitleStyle, {
    fontFamily: titleFontFamily,
    fontSize: titleFontSize,
    fontWeight: titleFontWeight,
    fontStyle: titleFontStyle,
    letterSpacing: titleLetterSpacing,
    lineHeight: titleLineHeight,
    textTransform: titleTextTransform,
    textAlign: titleTextAlign,
    color: titleColor,
    textShadow: titleTextShadow,
  });
  const titleStyle = {
    ...titlePresentation.style,
    // CSS Variables pour les couleurs d'animation du titre
    ...(titleAnimClass &&
      titleAnimationColors && {
        "--anim-primary": titleAnimationColors.primary,
        "--anim-accent": titleAnimationColors.accent,
      }),
  };

  // Style inline du lien:
const linkStyle = {
    fontFamily     : linkFontFamily,
    fontSize       : linkFontSize,
    fontWeight     : linkFontWeight,
    fontStyle      : linkFontStyle,
    letterSpacing  : linkLetterSpacing,
    textTransform  : linkTextTransform,
    textDecoration : linkTextDecoration,
    color          : linkColor,
    backgroundColor: linkBackgroundColor,
    padding        : linkPadding,
    borderRadius   : linkBorderRadius,
    textShadow     : linkTextShadow,
    '--link-hover-color': linkHoverColor, // CSS var pour le :hover
};

// Texte résolu via la clé de traduction:
const resolvedLinkText =
    infoSource?.laguangeElakay?.("Link", infoSource?.languageAPI)?.[linkText]
    || "See More";

const resolvedTitle = titleKey
  ? infoSource?.laguangeElakay?.(
      "frontElakayHardcodedText",
      infoSource?.languageAPI
    )?.pagesConfig?.[titleKey] || title
  : title;

const {divFollowSliderMatrix} = infoSource || {};
  return (
   <div
    ref={divFollowSliderMatrix}
    className={containerClass}
    style={isAnimated ? animationStyle : containerStyle}
>
      {/* Header */}
      {inView && (resolvedTitle || linkSlider) && (
        <div className={headerClass} style={headerStyle}>
          {resolvedTitle ? (
            <h2 className={`${titleClass} ${titlePresentation.className}`} style={titleStyle}>
              {resolvedTitle}
            </h2>
          ) : null}
          {linkSlider ? (
            <Link
              className={`slider-link ${classLink || ""}`}
              to={linkSlider}
              style={linkStyle}
            >
              {resolvedLinkText}
            </Link>
          ) : null}
        </div>
      )}

      {/* Swiper */}
      <Swiper
        key={swp.key}
        {...swp.swiperProps}
        slidesPerGroupSkip={1}
        style={{
          "--swiper-navigation-color": colors?.primary || "#007399",
          "--swiper-pagination-color": colors?.primary || "#007399",
          ...swp.style,
        }}
        className={`${swiperClass} ${swp.className}`}
      >
        {processData(productsrMatrix)?.map((products, index) => (
          <SwiperSlide key={index}>
            <div
              className={`page-matrix-slide ${isAnimated ? animationClass : ""}`}
            >
              <FollowPageMatrice
                products={products}
                title={true}
                arrayFacet={arrayFacet}
                headerBackgroundImage={toImageUrl(
                  getImageUrl(getLastItem(products.products))
                )}
                {...props}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SwiperPageMatrix;

/* ============================================
   📚 DOCUMENTATION DES PROPS
   ============================================

   🎬 ANIMATION CONTAINER (type_Animation)
   ----------------------------------------
   Valeurs: "0_type_Animation" à "32_type_Animation"
   
   | Type | Nom                    | Description                    |
   |------|------------------------|--------------------------------|
   | 0    | Arc-en-ciel           | Bandes traversantes multicolores |
   | 1    | Rose/Violet           | Lumières roses et violettes    |
   | 2    | Vert/Jaune            | Lumières vertes et jaunes      |
   | 3    | Orange/Rouge          | Lumières chaudes               |
   | 4    | Bleu/Indigo           | Lumières bleues profondes      |
   | 5    | Cyan/Teal             | Lumières cyan                  |
   | 6    | Or/Bronze             | Premium doré                   |
   | 7    | Argent/Platine        | Élégant argenté                |
   | 8    | Neon Magenta/Cyan     | Néon vibrant                   |
   | 9    | Rainbow               | Arc-en-ciel complet            |
   | 10   | Deep Purple           | Violet profond                 |
   | 11   | Lime/Chartreuse       | Vert lime                      |
   | 12   | Pink/Fuchsia          | Rose fuchsia                   |
   | 13   | Amber/Honey           | Ambre miel                     |
   | 14   | Brown/Tan             | Marron naturel                 |
   | 15   | Blue Grey             | Gris bleuté                    |
   | 16   | Coral/Peach           | Corail doux                    |
   | 17   | Turquoise Premium     | Blanc et turquoise             |
   | 18   | Matrix Green          | Digital Rain vert              |
   | 19   | Neon Glow             | Néon rose/cyan                 |
   | 20   | Liquid Purple         | Violet liquide                 |
   | 21   | Holographic           | Prisme multicolore             |
   | 22   | Electric Yellow       | Jaune électrique               |
   | 23   | Sunset                | Coucher de soleil              |
   | 24   | Ocean                 | Bleu océan                     |
   | 25   | Smoke                 | Fumée grise                    |
   | 26   | Confetti              | Fête multicolore               |
   | 27   | Sparkle Stars         | Étoiles scintillantes          |
   | 28   | Tech Blue             | Bleu technologique             |
   | 29   | Soft Pink             | Rose doux                      |
   | 30   | Lavender              | Lavande morphing               |
   | 31   | Energy Burst          | Explosion d'énergie            |
   | 32   | Aurora                | Aurore boréale                 |

   🎨 PROPS TITRE
   ----------------------------------------
   titleFontFamily    : Police ("Arial", "Roboto", "Poppins")
   titleFontSize      : Taille ("1.5rem", "2rem", "24px")
   titleFontWeight    : Graisse (400-900)
   titleFontStyle     : Style ("normal", "italic")
   titleLetterSpacing : Espacement ("-1px", "2px")
   titleLineHeight    : Hauteur ligne (1, 1.2, 1.5)
   titleTextTransform : Transform ("uppercase", "capitalize")
   titleTextAlign     : Alignement ("left", "center", "right")
   titleColor         : Couleur du texte ("#1f2937")
   titleTextShadow    : Ombre du texte

   🎬 PROPS ANIMATION TITRE
   ----------------------------------------
   titleAnimation       : "animated_0" à "animated_32" ou false
   titleAnimationColors : { primary: "#...", accent: "#..." }

   🎬 PROPS ANIMATION HEADER
   ----------------------------------------
   headerAnimation       : "animated_0" à "animated_32" ou false
   headerAnimationColors : { primary: "#...", accent: "#..." }
   headerBackgroundColor : Couleur de fond
   headerPadding         : Padding personnalisé
   headerMarginBottom    : Marge en bas

   📝 EXEMPLES D'UTILISATION
   ----------------------------------------

   // Exemple 1: Animation complète assortie
   <SwiperPageMatrix
     type_Animation="17_type_Animation"
     title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).swiperUserSwiperPageMatrix.t001}
     inView={true}
   />

   // Exemple 2: Titre personnalisé sans animation
   <SwiperPageMatrix
     title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).swiperUserSwiperPageMatrix.t002}
     titleFontFamily="Poppins"
     titleFontSize="2rem"
     titleFontWeight={800}
     titleColor="#1a1a1a"
     titleAnimation={false}
     headerAnimation={false}
     inView={true}
   />

   // Exemple 3: Animations différentes pour chaque élément
   <SwiperPageMatrix
     type_Animation="17_type_Animation"
     titleAnimation="animated_6"
     titleAnimationColors={{ primary: "#ffd700", accent: "#cd7f32" }}
     headerAnimation="animated_9"
     title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).swiperUserSwiperPageMatrix.t003}
     inView={true}
   />

   // Exemple 4: Titre centré avec style premium
   <SwiperPageMatrix
     title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).swiperUserSwiperPageMatrix.t004}
     titleFontFamily="'Playfair Display', serif"
     titleFontSize="2.5rem"
     titleFontWeight={500}
     titleTextTransform="uppercase"
     titleTextAlign="center"
     titleLetterSpacing="3px"
     titleColor="#1a1a1a"
     titleAnimation="animated_31"
     headerBackgroundColor="rgba(255,255,255,0.8)"
     headerPadding="1.5rem"
     inView={true}
   />

   // Exemple 5: Style Matrix/Tech
   <SwiperPageMatrix
     type_Animation="18_type_Animation"
     title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).swiperUserSwiperPageMatrix.t005}
     titleFontFamily="'Courier New', monospace"
     titleColor="#00ff41"
     titleTextShadow="0 0 10px #00ff41"
     inView={true}
   />

*/
